import React from 'react';

/**
 * Appkit 4 "close-outline" icon, inlined as a React component so it can be
 * recolored via `currentColor` and styled with CSS.
 *
 * Source: Icon/Outline/close-outline. The original `fill="#474747"` has been
 * replaced with `currentColor`.
 *
 * @param {React.SVGProps<SVGSVGElement>} props
 */
export default function CloseOutlineIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      role="img"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g transform="translate(0.750925, 0.749075)" fill="currentColor">
        <path
          fillRule="nonzero"
          d="M11.2703555 10.2291233 21.4772728.0222059896 22.4981496 1.04308277 12.2912323 11.25 22.4796446 21.4384123 21.4569173 22.4611396 11.268505 12.2727273 1.02087678 22.5203556 0 21.4994788 10.2476283 11.2518506.0185049901 1.02272728 1.04123227 0z"
        />
      </g>
    </svg>
  );
}
